import { makeStyles } from "@material-ui/core";

export default makeStyles(
  (theme) => ({
    root: {
      textAlign: "left",
    },
    row: {
      display: "flex",
      flexDirection: "row",
    },
    description: {
      display: "inline-block",
      maxWidth: 400,
      verticalAlign: "middle",
      fontSize: theme.typography.pxToRem(14),
      [theme.breakpoints.up("mobile")]: {
        marginLeft: 15,
        fontSize: theme.typography.pxToRem(16),
      },
    },
  }),
  { name: "EmailPreferences" },
);
